(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/start-page.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/start-page.js');
"use strict";


const CampaignFlerp = svs.components.lbUi.campaignFlerp.CampaignFlerp;
function getFund(draw) {
  const fund = {};
  if (draw && draw.fund !== null) {
    if (draw.fund.rolloverIn !== '0,00') {
      fund.rollingPool = draw.fund.rolloverIn;
    }
    if (draw.fund.extraMoney !== '0,00') {
      fund.extraMoney = draw.fund.extraMoney;
    }
  }
  return fund;
}
const getAllBetTypesForEvent = (drawEvents, matchId) => {
  const betTypes = [];
  _.each(drawEvents, event => {
    if (event.match && parseInt(event.match.matchId, 10) === parseInt(matchId, 10)) {
      betTypes.push(event.eventComment);
    }
  });
  return betTypes.join(', ');
};
const getHomeAndAwayTeam = match => {
  const homeAndAwayTeamName = {
    awayTeamName: '',
    homeTeamName: ''
  };
  let useShortName = false;
  if (match && match.participants && Array.isArray(match.participants) && match.participants.length >= 2) {
    useShortName = match.participants[0].name.length + match.participants[1].name.length > 38;
    homeAndAwayTeamName.homeTeamName = useShortName ? match.participants[0].mediumName : match.participants[0].name || '';
    homeAndAwayTeamName.awayTeamName = useShortName ? match.participants[1].mediumName : match.participants[1].name || '';
  }
  return homeAndAwayTeamName;
};
const checkForLeagueName = (drawEvents, currentMatchId) => {
  let leagueName = '';
  leagueName = _.find(drawEvents, event => currentMatchId && event.participantType.toLowerCase() !== 'player' && event.match && event.match.league && event.match.league.name).match.league.name;
  return leagueName;
};
const getMatches = drawEvents => {
  const matches = [];
  let betTypes;
  let lastMatchId;
  let leagueName;
  let teamNames;
  const sport = {
    isMixed: false,
    sportType: undefined
  };
  drawEvents.forEach(event => {
    if (event.match && parseInt(lastMatchId, 10) !== parseInt(event.match.matchId, 10)) {
      if (matches.length < svs.challenge.constants.MAX_MATCHES_IN_STARTPAGE) {
        if (event.participantType.toLowerCase() === 'player') {
          leagueName = checkForLeagueName(drawEvents, event.match.matchId);
        } else if (event.match.league && event.match.league.name) {
          leagueName = event && event.match && event.match.league ? event.match.league.name : '';
        }
        teamNames = getHomeAndAwayTeam(event.match);
        betTypes = getAllBetTypesForEvent(drawEvents, event.match.matchId);
        if (event.match && event.match.sport && event.match.sport.type) {
          if (sport.sportType === undefined || event.match.sport.type === sport.sportType) {
            sport.sportType = event.match.sport.type;
          } else if (event.match.sport.type !== sport.sportType) {
            sport.isMixed = true;
            matches.forEach(match => {
              match.sport.isMixed = true;
            });
          }
        }
        matches.push({
          awayTeam: teamNames.awayTeamName || 'borta',
          betTypes,
          homeTeam: teamNames.homeTeamName || 'hemma',
          league: leagueName,
          sport
        });
        lastMatchId = event.match.matchId;
      }
    }
  });
  return matches;
};
const getPromoItemMatches = coupon => {
  let matches = [];
  if (coupon && Array.isArray(coupon.drawEvents)) {
    matches = getMatches(coupon.drawEvents);
  }
  return matches;
};
const getRoundItems = (history, draws) => {
  const collection = new Backbone.Collection();
  draws.forEach((draw, index) => {
    if (index === 0) {
      return;
    }
    const matches = getMatches(draw.drawEvents);
    const _getFund = getFund(draw),
      rollingPool = _getFund.rollingPool,
      extraMoney = _getFund.extraMoney;
    collection.add(new Backbone.Model({
      callback: () => {
        history.push("/spela/".concat(draw.drawNumber));
      },
      extraMoney,
      matches,
      revenue: parseInt(draw.currentNetSale, 10),
      rollingPool,
      stopDate: new Date(draw.regCloseTime).getTime(),
      stopDateLabel: 'Spelstopp: ',
      title: draw.drawComment.toUpperCase(),
      useBackground: true
    }));
  });
  return collection;
};
class StartPage extends React.Component {
  getStartPageConfig() {
    const _this$props = this.props,
      history = _this$props.history,
      draws = _this$props.draws,
      firstCoupon = _this$props.firstCoupon,
      firstDraw = _this$props.firstDraw,
      openXperten = _this$props.openXperten;
    const promoItems = new Backbone.Collection();
    const roundItems = getRoundItems(history, draws);
    if (firstCoupon && firstDraw) {
      const _getFund2 = getFund(firstDraw),
        rollingPool = _getFund2.rollingPool,
        extraMoney = _getFund2.extraMoney;
      promoItems.add({
        buttons: [{
          callback: () => {
            history.push("/spela/".concat(firstDraw.drawNumber));
          },
          label: 'Spela Challenge'
        }, {
          callback: () => {
            history.push("/spela/".concat(firstDraw.drawNumber));
            openXperten();
          },
          label: 'PIX!'
        }],
        drawNumber: firstDraw.drawNumber,
        extendedTitle: {
          extraMoney,
          revenue: parseInt(firstDraw.currentNetSale, 10),
          rollingPool
        },
        infoBar: {
          date: new Date(firstDraw.regCloseTime).getTime(),
          label: 'NÄSTA',
          stopDateLabel: 'Spelstopp: '
        },
        matches: getPromoItemMatches(firstDraw),
        showTitleBar: true,
        title: firstDraw.drawComment.toUpperCase()
      });
    }
    return {
      footerRegion: {
        buttons: new Backbone.Collection(svs.challenge.data.config.startPageConfig.links)
      },
      generalSettings: {
        branding: 'oddset'
      },
      promoRegion: {
        matchPromo: {
          items: promoItems,
          settings: new Backbone.Model({
            backgroundImageLarge: svs.challenge.data.config.startPageConfig.promo.startPageBackground,
            noOpenDrawsText: 'Inga öppna omgångar för tillfället. <br />Återkom om en kort stund.'
          })
        }
      },
      roundsRegion: {
        items: roundItems
      },
      tabRegion: new Backbone.Model({
        buttons: [{
          inverted: true,
          label: 'Spela'
        }],
        items: svs.challenge.data.config.startPageConfig.tabs
      })
    };
  }
  render() {
    const ProductStartPage = svs.utils.reactHelpUtils.wrapView(svs.app.productStartPage.ProductStartPage);
    return React.createElement(React.Fragment, null, React.createElement(CampaignFlerp, {
      branding: "challenge"
    }), React.createElement(ProductStartPage, {
      options: this.getStartPageConfig()
    }));
  }
}
const getFirstCoupon = state => {
  if (Array.isArray(state.coupons) && state.coupons.length > 0) {
    return state.coupons[0];
  }
};
const getFirstDraw = state => {
  if (Array.isArray(state.draws) && state.draws.length > 0) {
    return state.draws[0];
  }
};
const mapStateToProps = state => ({
  draws: state.draws,
  firstCoupon: getFirstCoupon(state),
  firstDraw: getFirstDraw(state)
});
const mapDispatchToProps = {
  openXperten: svs.challenge.actions.openXperten
};
svs.challenge.StartPage = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(StartPage);

 })(window);